export default "__VITE_ASSET__CV4F6bOC__"